export const modalFormContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: '0 16px 16px',
};

export const labelStyles = {
  alignItems: 'flex-start',
  mx: 0,
  width: '100%',
};

export const createBlockStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 2,
  mt: 4,
};

export const createBlockContainerStyles = {
  border: '1px solid #00000033',
  borderRadius: '8px',
  p: 4,
};

export const detailsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '3rem',
  mt: '2.5rem',
};

export const disabledStudioCreationChipStyles = {
  backgroundColor: 'neutral10.main',
  fontSize: 14,
  width: '48%',
  height: 'fit-content',
  alignItems: 'center',
  padding: 2,
};

export const clusterFormContainerStyles = {
  maxHeight: '70vh',
  overflowY: 'auto',
  p: 2,
  pb: 10,
};
